import { useSelector } from "react-redux";
import useScreenLogger from "../../utils/useScreenLogger";

const ScreenTracker = () => {
  const { user } = useSelector((state) => state.common);

  useScreenLogger(user);

  return null; // no UI impact
};

export default ScreenTracker;
